export default function getResource(label, vars = []) {
    const resources = {
        cardTitle: 'Paiement',
        expires: 'Exp.',
        useGiftCard: 'Utiliser une carte-cadeau',
        paypalRestrictedItemError: 'L’un des articles de votre panier ne peut pas être acheté avec Paypal. Veuillez supprimer l’article pour payer avec Paypal ou bien utilisez un autre mode de paiement pour passer à la caisse avec cet article.',
        giftCardNumber: 'Numéro de carte-cadeau',
        pin: 'NIP',
        applyBtn: 'Appliquer',
        cancelBtn: 'Annuler',
        maxGiftCards: 'Vous avez atteint le nombre maximal de cartes-cadeaux que vous pouvez utiliser pour cette commande.',
        giftCard: 'Carte-cadeau',
        applied: 'appliqué',
        remove: 'Retirer',
        secure: 'Sûr',
        payPalAccount: 'Compte PayPal',
        payWithPayPal: 'Payer avec PayPal',
        payNow: 'Payez maintenant',
        or: 'ou',
        payLaterWithPayPal: 'Payez plus tard avec PayPal',
        payWithApplePay: 'Payer avec ApplePay',
        addNewCreditCard: 'Ajouter une nouvelle carte de crédit ou de débit',
        addNewCard: 'Ajouter une nouvelle carte',
        useThisCard: 'Utiliser cette carte',
        debitCardDisclaimer: 'Cartes de débit Visa et Mastercard seulement',
        payPalDisabled: 'PayPal ne peut pas être utilisé pour l’achat d’un abonnement.',
        verifyCVV: 'Aucun paiement n’est requis. Veuillez vérifier votre numéro CVV/CVC à des fins de sécurité.',
        accountCredit: 'Crédit au compte',
        giftCardsNotCombinable: 'Les cartes-cadeaux ne peuvent pas être combinées avec ce mode de paiement.',
        removeCreditCard: 'Supprimer la carte de crédit ou la carte de débit',
        areYouSureMessage: 'Êtes-vous sûr de vouloir supprimer cette carte de façon définitive?',
        removeGiftCard: 'Supprimer la carte-cadeau',
        areYouSureGiftCardMessage: 'Voulez-vous vraiment supprimer cette carte-cadeau de votre commande?',
        cancel: 'Annuler',
        expiredCreditCardMsg: 'Cette carte est expirée. Veuillez effectuer une mise à jour des renseignements de votre carte.',
        edit: 'Modifier',
        gotIt: 'Compris',
        cvc: 'CVV/CVC',
        moreInfoCvc: 'Plus d’informations relatives au CVC',
        showAll: 'Afficher tout',
        showLess: 'Afficher moins',
        storeCreditApplied: 'Crédit au compte',
        storeCreditNotEnoughMessage: 'Le solde de votre crédit au compte est inférieur au total de la commande. Veuillez ajouter un mode de paiement supplémentaire.',
        accountCreditAltText: 'Crédit au compte Sephora',
        paymentMethodSelection: 'Sélection du mode de paiement',
        paymentInformation: 'Informations sur le paiement',
        somePaymentCannotUsed: 'Certains modes de paiement ne peuvent pas être utilisés pour l’achat d’un abonnement.',
        removeAddress: 'Supprimer l’adresse',
        maxCreditCardsMessage: `Vous pouvez avoir jusqu’à ${vars[0]} cartes de crédit. Veuillez en supprimer une et en ajouter une autre à nouveau.`,
        continueButton: 'Continuer',
        editPaypal: 'Modifier',
        otherWaysToPay: 'Autres modes de paiement',
        interestFreeMessage: `Ou payez en quatre versements sans intérêt de ${vars[1]} avec ${vars[1]}.`,
        orPayInFour: 'Ou payez en quatre versements sans intérêt de',
        payWith: 'Payer avec',
        installmentsMessage: `Quatre versements sans intérêt de ${vars[0]} $`,
        availableWith: 'disponible avec',
        afterpayHeader: 'Payer avec Cash App pour Afterpay',
        afterpaySubtitle: `Quatre versements sans intérêt de ${vars[0]} $`,
        afterpaySaveAndContinue: 'Enregistrer et continuer',
        afterpayCancel: 'Annuler',
        afterpayContinueWithAfterpay: 'Continuer avec Afterpay',
        afterpayLoading: 'Chargement des détails d’Afterpay…',
        afterpayErrorMessage: 'Impossible de charger les renseignements d’Afterpay. Veuillez essayer de nouveau.',
        afterpayApiErrorFallback: 'Divisez votre paiement en quatre versements sans intérêt avec Afterpay.',
        afterpayGiftCardWarning: 'Les cartes-cadeaux ne peuvent être combinées à Cash App pour Afterpay. Si vous voulez utiliser une carte-cadeau, veuillez choisir un autre mode de paiement.',
        afterpayLegalNotice: 'En cliquant sur « Continuer vers Cash App pour Afterpay », j’indique à Sephora d’envoyer ma commande et mes renseignements de facturation à Afterpay et je comprends que ces renseignements sont assujettis aux <a href=\'https://www.afterpay.com/en-US/terms-of-service\' target=\'_blank\'>modalités</a> et à la <a href=\'https://www.afterpay.com/en-US/privacy-policy\' target=\'_blank\'>politique de confidentialité</a> d’Afterpay.',
        venmoHeader: 'Payer avec Venmo',
        venmoSaveAndContinue: 'Enregistrer et continuer',
        klarnaHeader: 'Payer avec Klarna',
        klarnaSaveAndContinue: 'Enregistrer et continuer',
        klarnaCancel: 'Annuler',
        klarnaLoading: 'Chargement des options de paiement Klarna…',
        klarnaApiErrorFallback: 'Impossible de charger les informations de paiement Klarna. Veuillez réessayer ou choisir un autre mode de paiement.',
        klarnaTimeoutError: 'La demande a expiré. Veuillez essayer de nouveau.',
        klarnaNetworkError: 'Erreur de réseau. Veuillez vérifier votre connexion Internet et essayez de nouveau.',
        klarnaSubtitle: `Payez en quatre versements sans intérêt de ${vars[0]}`,
        klarnaGiftCardWarning: 'Les cartes-cadeaux ne peuvent être combinées à Klarna. Si vous voulez utiliser une carte-cadeau, veuillez choisir un autre mode de paiement.',
        klarnaFeatureBuyerProtection: 'Profitez de <a href="https://www.klarna.com/us/buyer-protection/" target="_blank">la protection du consommateur </a> avec Klarna. Voir <a href="https://www.klarna.com/us/customer-service/" target="_blank">les options de paiement.</a>',
        klarnaTermsText: 'En continuant, j’accepte les <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx" target="_blank">conditions de service d’achat de Klarna </a> et <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy" target="_blank">l’avis de confidentialité de Klarna </a> et je confirme que j’ai lu l’avis sur les témoins de Klarna <a href="https://www.klarna.com/us/legal/" target="_blank">.</a>',
        klarnaLegalNotice: 'En cliquant sur « Continuer vers Klarna », je demande à Sephora d’envoyer mes renseignements de commande et de facturation à Karna et je comprends que ces renseignements seront assujettis aux conditions Karna et à sa politique de confidentialité.',
        klarnaBillingAddressCheckbox: 'Mon adresse de facturation est la même que mon adresse d’expédition',
        pazeHeader: 'Pay with Paze',
        pazeSubtitle: 'Available for consumers of participating banks and credit unions',
        pazeGiftCardWarning: 'Gift cards are not combinable with Paze. If you want to use a gift card, please select another payment method.',
        pazeSaveAndContinue: 'Save and Continue',
        pazeCancel: 'Cancel'
    };

    return resources[label];
}
